module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--procedures-b8a7a87c49e98301c70a52eb0e797283.jpg";